import React from "react";
import PropTypes from "prop-types";

function RadioItem(props) {
    let styleCustom = {};
    let margin = "";
    if (props.horizontal) {
        styleCustom = { display: "inline" };
        margin = " ml-2";
    }
    return (
        <div
            className={"radio radio-css" + margin + " mt-1"}
            style={styleCustom}
        >
            <input
                type="radio"
                name="radio_css"
                id={props.id}
                defaultChecked={props.defaultChecked}
                onChange={props.onChange}
            />
            <label htmlFor={props.id}>
                <h5>{props.label}</h5>
                {props.sublabel && <span>{props.sublabel}</span>}
            </label>
        </div>
    );
}

RadioItem.propTypes = {
    id: PropTypes.string,
    defaultChecked: PropTypes.bool,
    onChange: PropTypes.func,
    label: PropTypes.string,
    horizontal: PropTypes.bool,
    sublabel: PropTypes.string,
};

export { RadioItem as default };
